module.exports = __webpack_public_path__ + "static/media/small.c428ebe0.png";